import { fetchWrapper } from "../Helpers/fetch-wrapper";
import { toApiPage } from "./queryParams";

const getAllOrganisations = async (
  page,
  pageSize,
  sortBy,
  sortOrder,
  filters
) => {
  let params = [];
  if (page || page === 0) params.push("page=" + toApiPage(page));
  if (pageSize) params.push("pageSize=" + pageSize);
  if (sortBy) params.push("sortBy=" + sortBy);
  if (sortOrder) params.push("sortOrder=" + sortOrder);
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        let param = "";
        param += `filters[${key}]=[`;
        let values = value.map((ele) => ele.id);
        values.join(",");
        param += values;
        param += `]`;
        params.push(param);
      } else if (typeof value == "string" && value) {
        params.push(`filters[${key}]=${value}`);
      }
    });
  }
  const response = fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/organisation${
      params !== "" ? "?" + params.join("&") : ""
    }`
  );

  return response;
};

const getOrganisationsById = async (id) => {
  const response = fetchWrapper.get(
    `${process.env.REACT_APP_API_ENDPOINT}/organisation/${id}`
  );
  return response;
};

const createOrganisation = async (params) => {
  const response = fetchWrapper.post(
    `${process.env.REACT_APP_API_ENDPOINT}/organisation`,
    {
      name: params.name || undefined,
      email: params.email || undefined,
      telephone: params.telephone || undefined,
      address: params.address || undefined,
      post_code: params.post_code || undefined,
      licenses: params.licenses || undefined,
      swp_org_id: params.swp_org_id || undefined,
    }
  );
  return response;
};

const updateOrganisations = async (id, params) => {
  const response = fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/organisation/${id}`,
    {
      name: params.name || undefined,
      email: params.email || undefined,
      telephone: params.telephone || undefined,
      address: params.address || undefined,
      post_code: params.post_code || undefined,
      licenses: params.licenses || undefined,
      swp_org_id: params.swp_org_id || undefined,
    }
  );
  return response;
};

const disableOrganisation = async (id) => {
  const response = fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/organisation/${id}/setactive`,
    {'active': 0}
  );
  return response;
};

const enableOrganisation = async (id) => {
  const response = fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/organisation/${id}/setactive`,
    {'active': 1}
  );
  return response;
};

export const OrganisationsService = {
  getAllOrganisations,
  getOrganisationsById,
  createOrganisation,
  updateOrganisations,
  disableOrganisation,
  enableOrganisation,
};
